export const BRANDS = [
  { k: "generic", label: "RTSP (URL manual)", port: 554, path: "" },
  { k: "hikvision", label: "Hikvision / HiLook / Annke", port: 554, path: "/Streaming/Channels/{ch}0{sub}" },
  { k: "dahua", label: "Dahua / Imou / Amcrest", port: 554, path: "/cam/realmonitor?channel={ch}&subtype={sub}" },
  { k: "tapo", label: "TP-Link Tapo", port: 554, path: "/stream{s1}" },
  { k: "reolink", label: "Reolink", port: 554, path: "/h264Preview_0{ch}_{mainsub}" },
  { k: "ezviz", label: "EZVIZ", port: 554, path: "/H.264" },
  { k: "xiaomi", label: "Xiaomi / Wyze (firmware RTSP)", port: 554, path: "/live" },
  { k: "uniview", label: "Uniview", port: 554, path: "/unicast/c{ch}/s{sub}/live" },
  { k: "onvif", label: "ONVIF genérico", port: 554, path: "/onvif{ch}" },
  { k: "ipwebcam", label: "Android: IP Webcam (app)", port: 8080, path: "/video", scheme: "http" },
  { k: "droidcam", label: "Android/iPhone: DroidCam", port: 4747, path: "/video", scheme: "http" },
];

export function buildUrl({ brand, ip, port, user, pass, channel = 1, sub = false }) {
  const b = BRANDS.find((x) => x.k === brand) || BRANDS[0];
  if (!ip) return "";
  const scheme = b.scheme || "rtsp";
  const auth = user ? `${encodeURIComponent(user)}${pass ? `:${encodeURIComponent(pass)}` : ""}@` : "";
  const p = port || b.port;
  const path = b.path.replace("{ch}", channel).replace("{sub}", sub ? 1 : 0).replace("{s1}", sub ? 2 : 1).replace("{mainsub}", sub ? "sub" : "main");
  return `${scheme}://${auth}${ip}:${p}${path}`;
}
